import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Select organization", -1)
const _hoisted_3 = { class: "q-py-md row justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_q_select, {
      modelValue: _ctx.selectedOrganization,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOrganization) = $event)),
      options: _ctx.filteredOptions,
      dense: "",
      label: "Organization",
      outlined: "",
      "map-options": "",
      "emit-value": "",
      onFilter: _ctx.filterFn,
      "use-input": ""
    }, null, 8, ["modelValue", "options", "onFilter"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_btn, {
        label: "Back",
        color: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goBack())),
        outline: "",
        unelevated: "",
        "no-caps": ""
      }),
      (_ctx.selectedOrganization !== null)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            label: "Proceed",
            color: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goProceed(_ctx.selectedOrganization))),
            unelevated: "",
            "no-caps": ""
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}